<template>
  <div class="flex flex-col min-h-screen">
    <div class="flex items-center justify-center h-16 py-2 bg-dark-type-1">
      <router-link to="/">
        <img src="@/assets/img/logo.png" style="width: 160px" alt="Shuttlers" />
      </router-link>
    </div>
    <div class="flex flex-1 flex-col md:px-24 pt-16">
      <div
        v-if="showBackButton"
        class="flex items-center cursor-pointer px-8"
        @click="goBack"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 12L18 12M11 7L6 12L11 7ZM6 12L11 17L6 12Z"
              stroke="#000005"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="text-sm font-medium pt-1">Back</span>
      </div>
      <div class="flex flex-1 flex-col items-center mt-16">
        <login
          :show-close-toggle="false"
          :go-back="showBackButton"
          @show-back-button="onShowBackButton"
        ></login>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/Login";

export default {
  components: {
    Login,
  },
  data() {
    return {
      showBackButton: false,
    };
  },
  methods: {
    goBack() {
      this.showBackButton = false;
    },
    onShowBackButton() {
      this.showBackButton = true;
    },
  },
};
</script>